import type { AIVoice } from 'js/src/client';
import PlainJsStoreORM from 'js/src/data/plain-js-store-orm';
import type { RootState } from 'js/src/libs/RootState';

export function getAIVoicesState(state: RootState) {
    return state.aiVoicesAndAvatars.aiVoices;
}

function getAIVoicesStoreORM(aiVoicesState: ReturnType<typeof getAIVoicesState>) {
    return new PlainJsStoreORM(aiVoicesState);
}

export function getAIVoiceIds(state: RootState): string[] {
    return getAIVoicesStoreORM(getAIVoicesState(state)).allIds;
}

export function getAIVoiceById(state: RootState, id: string): AIVoice | null {
    return getAIVoicesStoreORM(getAIVoicesState(state)).getById(id) || null;
}
